import React, {useEffect, useState} from "react";
import AlbumList from "../components/album-list";
import ReactGA from "react-ga";
import axios, {AxiosResponse} from "axios";
import _ from "lodash"
import {AlbumInfo} from "../models/responses";
import {getTrendingUrl} from "../helpers/UrlHelper";

function TrendingPage() {

    const [albums, setAlbums] = useState<AlbumInfo[]>([]);

    useEffect(() => {
        ReactGA.initialize('UA-145092517-1')
        ReactGA.pageview('/trending')

        axios.get(getTrendingUrl)
            .then((response: AxiosResponse<{ albums: AlbumInfo[] }>) => {
                setAlbums(_.sortBy(response.data.albums, (a) => a.id).reverse());
            }).catch((error) => {
            console.error(error)
        })
    }, [])

    return (
        <>
            <div className="album-info">
                <div className="album-title">
                    <span>Trending Albums</span>
                    <span className="horizontal-line"></span>
                </div>
            </div>

            <AlbumList albums={albums}/>
        </>
    )
}

export default TrendingPage;